export default __webpack_public_path__ + "static/media/image.vision8-r-d.3428be9b.png";